import { Named } from './named';
import { IViolation } from './annotation';
import { sanitizeAndFormatString } from '../../shared/utils/string.util';
import { shellStringResources } from '../../Resources/ShellStringResources';

export class NamedValidations {
    private static readonly _keyWords = ['type'];

    // eslint-disable-next-line @typescript-eslint/naming-convention
    public static KeyWordsValidator<T extends Named>(named: T): IViolation[] {
        if (named?.name && NamedValidations._keyWords.includes(named.name.toLowerCase())) {
            return [{
                message: () => sanitizeAndFormatString(shellStringResources.Named_Keyword_ValidationError, named.name),
                revalidate: () => NamedValidations.KeyWordsValidator<T>(named).length === 0,
                logDetails: {
                    functionName: 'NamedValidations.KeyWordsValidator',
                    errorType: 'Pattern'
                }
            }];
        }

        return [];
    }

    // eslint-disable-next-line @typescript-eslint/naming-convention
    public static StartsWithNumberValidator<T extends Named>(named: T): IViolation[] {
        const numberRegex = /^\d/;
        if (named?.name && numberRegex.test(named.name)) {
            return [{
                message: () => sanitizeAndFormatString(shellStringResources.Named_StartsWithNumber_ValidationError, named.name),
                revalidate: () => NamedValidations.StartsWithNumberValidator<T>(named).length === 0,
                logDetails: {
                    functionName: 'NamedValidations.StartsWithNumberValidator',
                    errorType: 'Pattern'
                }
            }];
        }

        return [];
    }
}
